import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {SYSTEM_TYPES} from "../../../Library/libraryConstants";
import {getSystemTypeTextByValue} from "../../../Library/libraryUtility";
import {aphLoanHistoryItemModel} from "./aphLoanHistoryFactory";
import {aphLoanHistoryApi} from "./aphLoanHistoryApi";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {PageTitle} from "../../../../Components/Landmarks";
import {AphLoanHistorySearchFormView} from "./AphLoanHistorySearchFormView";
import {LayoutFullWidth} from "../../../../Components/Layout";
import {AphLoanHistoryView} from "./AphLoanHistoryView";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";

export const AphLoanHistoryContainer = ({
                                            aphLoanHistorySearchCriteria,
                                            handleApiCall,
                                            handleSetAphLoanHistorySearchCriteria,
                                            isLoading,
                                            redirect,
                                        }: ContextProps) => {

        const [aphLoanHistoryItems, setAphLoanHistoryItems] = useState<Record<string, any>[]>([]);
        const [aphLoanSearchDropDowns, setAphLoanSearchDropDowns] = useState<Record<string, unknown> | null>(null);
        const [totalRecords, setTotalRecords] = useState(0);

        const loadLoanHistoriesResults = (result: { data: Record<string, any>[]; totalRecords: number }) => {
            const loanHistoryItems = result.data.map((aphLoanHistoryItem: Record<string, any>) => aphLoanHistoryItemModel(aphLoanHistoryItem));
            setAphLoanHistoryItems(loanHistoryItems);
            setTotalRecords(result.totalRecords);
        };

        const handleExportLoansClick = () => {
            if(isArrayNullOrEmpty(aphLoanHistoryItems))
                alert("Search criteria has no results. Adjust your search and try again.")
            else
                handleApiCall(() => aphLoanHistoryApi.getAphLoanHistoryReport(aphLoanHistorySearchCriteria));
        }

        const handleGetAphLoanSearchDropDowns = () => {
            handleApiCall(() => aphLoanHistoryApi.getDropdownListsForAphLoanSearch(), (results: Record<string, unknown>) => setAphLoanSearchDropDowns(results));
        }

        useEffect(() => {

            if (!aphLoanSearchDropDowns)
                handleGetAphLoanSearchDropDowns();

            if (aphLoanHistorySearchCriteria.loadSearchResults) {
                const criteriaToSend = {
                    ...aphLoanHistorySearchCriteria,
                    isAphLoanHistory: true
                };
                handleApiCall(
                    () => aphLoanHistoryApi.getAphLoanHistory(criteriaToSend),
                    loadLoanHistoriesResults
                );
            }

        }, [aphLoanHistorySearchCriteria]);

        if (!aphLoanHistorySearchCriteria || isNullOrUndefined(aphLoanSearchDropDowns)) return null;

        return <>
            <PageTitle h1={`${getSystemTypeTextByValue(SYSTEM_TYPES.APH.toString())} Loan History`}/>
            {
                aphLoanSearchDropDowns && //students &&
                <div className={`searchBox`}>
                    <div className={`searchBox__title`}>Search for Loan History</div>
                    <AphLoanHistorySearchFormView
                        aphLoanHistorySearchCriteria={aphLoanHistorySearchCriteria}
                        aphLoanSearchDropDowns={aphLoanSearchDropDowns}
                        handleSetAphLoanHistorySearchCriteria={handleSetAphLoanHistorySearchCriteria}
                        isLoading={isLoading}
                    />
                </div>
            }

            <LayoutFullWidth className={`catalog`}>
                <header>
                    <h2>Search Results</h2>
                </header>
                <GridContainer isReverseOrder hasMarginX className={`form__header`}>
                    <GridCell
                        medium_columns={gridConstants.column.ONE}>
                        <ButtonLinkStyle
                            isCollapsed
                            label={`Export APH History`}
                            name="btnExportHistory"
                            onClick={handleExportLoansClick}
                        />
                    </GridCell>
                </GridContainer>


                <AphLoanHistoryView
                    aphLoanHistoryItems={aphLoanHistoryItems}
                    aphLoanHistorySearchCriteria={aphLoanHistorySearchCriteria}
                    handleSetAphLoanHistorySearchCriteria={handleSetAphLoanHistorySearchCriteria}
                    redirect={redirect}
                    totalRecords={totalRecords}
                />
            </LayoutFullWidth>
        </>;
    }
;
